export const artists = [
  {
    id: 'van-gogh',
    name: 'Vincent van Gogh',
    period: 'Post-Impressionism',
    familiarizationImages: [
      '/images/real/van-gogh/fam1.jpg',
      '/images/real/van-gogh/fam2.jpg',
      '/images/real/van-gogh/fam3.jpg',
      '/images/real/van-gogh/fam4.jpg',
      '/images/real/van-gogh/fam5.jpg',
      '/images/real/van-gogh/fam6.jpg'
    ]
  },
  {
    id: 'cezanne',
    name: 'Paul Cézanne',
    period: 'Post-Impressionism',
    familiarizationImages: [
      '/images/real/cezanne/fam1.jpg',
      '/images/real/cezanne/fam2.jpg',
      '/images/real/cezanne/fam3.jpg',
      '/images/real/cezanne/fam4.jpg',
      '/images/real/cezanne/fam5.jpg',
      '/images/real/cezanne/fam6.jpg'
    ]
  },
  {
    id: 'monet',
    name: 'Claude Monet',
    period: 'Impressionism',
    familiarizationImages: [
      '/images/real/monet/fam1.jpg',
      '/images/real/monet/fam2.jpg',
      '/images/real/monet/fam3.jpg',
      '/images/real/monet/fam4.jpg',
      '/images/real/monet/fam5.jpg',
      '/images/real/monet/fam6.jpg'
    ]
  },
  {
    id: 'picasso',
    name: 'Pablo Picasso',
    period: 'Cubism',
    familiarizationImages: [
      '/images/real/picasso/fam1.jpg',
      '/images/real/picasso/fam2.jpg',
      '/images/real/picasso/fam3.jpg',
      '/images/real/picasso/fam4.jpg',
      '/images/real/picasso/fam5.jpg',
      '/images/real/picasso/fam6.jpg'
    ]
  },
  {
    id: 'rembrandt',
    name: 'Rembrandt van Rijn',
    period: 'Dutch Golden Age',
    familiarizationImages: [
      '/images/real/rembrandt/fam1.jpg',
      '/images/real/rembrandt/fam2.jpg',
      '/images/real/rembrandt/fam3.jpg',
      '/images/real/rembrandt/fam4.jpg',
      '/images/real/rembrandt/fam5.jpg',
      '/images/real/rembrandt/fam6.jpg'
    ]
  },
  {
    id: 'warhol',
    name: 'Andy Warhol',
    period: 'Pop Art',
    familiarizationImages: [
      '/images/real/warhol/fam1.jpg',
      '/images/real/warhol/fam2.jpg',
      '/images/real/warhol/fam3.jpg',
      '/images/real/warhol/fam4.jpg',
      '/images/real/warhol/fam5.jpg',
      '/images/real/warhol/fam6.jpg'
    ]
  },
  {
    id: 'hokusai',
    name: 'Katsushika Hokusai',
    period: 'Japanese Ukiyo-e',
    familiarizationImages: [
      '/images/real/hokusai/fam1.jpg',
      '/images/real/hokusai/fam2.jpg',
      '/images/real/hokusai/fam3.jpg',
      '/images/real/hokusai/fam4.jpg',
      '/images/real/hokusai/fam5.jpg',
      '/images/real/hokusai/fam6.jpg'
    ]
  },
  {
    id: 'kahlo',
    name: 'Frida Kahlo',
    period: 'Mexican Modernism',
    familiarizationImages: [
      '/images/real/kahlo/fam1.jpg',
      '/images/real/kahlo/fam2.jpg',
      '/images/real/kahlo/fam3.jpg',
      '/images/real/kahlo/fam4.jpg',
      '/images/real/kahlo/fam5.jpg',
      '/images/real/kahlo/fam6.jpg'
    ]
  },
  {
    id: 'turner',
    name: 'J.M.W. Turner',
    period: 'Romanticism',
    familiarizationImages: [
      '/images/real/turner/fam1.jpg',
      '/images/real/turner/fam2.jpg',
      '/images/real/turner/fam3.jpg',
      '/images/real/turner/fam4.jpg',
      '/images/real/turner/fam5.jpg',
      '/images/real/turner/fam6.jpg'
    ]
  },
  {
    id: 'dali',
    name: 'Salvador Dalí',
    period: 'Surrealism',
    familiarizationImages: [
      '/images/real/dali/fam1.jpg',
      '/images/real/dali/fam2.jpg',
      '/images/real/dali/fam3.jpg',
      '/images/real/dali/fam4.jpg',
      '/images/real/dali/fam5.jpg',
      '/images/real/dali/fam6.jpg'
    ]
  },
  {
    id: 'vermeer',
    name: 'Johannes Vermeer',
    period: 'Dutch Golden Age',
    familiarizationImages: [
      '/images/real/vermeer/fam1.jpg',
      '/images/real/vermeer/fam2.jpg',
      '/images/real/vermeer/fam3.jpg',
      '/images/real/vermeer/fam4.jpg',
      '/images/real/vermeer/fam5.jpg',
      '/images/real/vermeer/fam6.jpg'
    ]
  },
  {
    id: 'klimt',
    name: 'Gustav Klimt',
    period: 'Art Nouveau',
    familiarizationImages: [
      '/images/real/klimt/fam1.jpg',
      '/images/real/klimt/fam2.jpg',
      '/images/real/klimt/fam3.jpg',
      '/images/real/klimt/fam4.jpg',
      '/images/real/klimt/fam5.jpg',
      '/images/real/klimt/fam6.jpg'
    ]
  }
];